import learningProgramWidget from "./LearningProgramWidget";
import compliancePassportWidget from "./CompliancePassportWidget";
import circularProgressWidget from "./CircularProgressWidget";
import learningBannerWidget from "./LearningBannerWidget";
import programStatusWidget from "./ProgramStatusWidget";
import notificationAlerts from "./NotificationAlerts";

export const LearningProgramWidget = learningProgramWidget;
export const CompliancePassportWidget = compliancePassportWidget;
export const CircularProgressWidget = circularProgressWidget;
export const LearningBannerWidget = learningBannerWidget;
export const ProgramStatusWidget = programStatusWidget;
export const NotificationAlerts = notificationAlerts;
